import { createSlice } from "@reduxjs/toolkit";
import { iPurchaseOrderListItem, REDUCER_NAME } from "./Types";
import { getPurchaseOrderList } from "./ThunkAction";

interface iPurchaseOrderState {
  isLoading: boolean;
  orders: iPurchaseOrderListItem[]; // renamed from `products`
  selectedOrder?: iPurchaseOrderListItem;
  errorMessage: string | null;
}

const initialState: iPurchaseOrderState = {
  isLoading: false,
  orders: [],
  selectedOrder: undefined,
  errorMessage: null,
};

export const polistSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetProductState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPurchaseOrderList.fulfilled, (state, action) => {
        const payload = action.payload as { data: iPurchaseOrderListItem | iPurchaseOrderListItem[] };
        
        if (payload && Array.isArray(payload.data)) {
          state.orders = payload.data as iPurchaseOrderListItem[]; // Cast explicitly to the expected type
        } else if (payload && payload.data) {
          state.orders = [payload.data as iPurchaseOrderListItem]; // Wrap and cast as an array
        }
      
        state.isLoading = false;
      })
      
      .addCase(getPurchaseOrderList.rejected, (state, action) => {
        state.errorMessage = (action.payload as { message?: string })?.message || "Failed to fetch products";
        state.isLoading = false;
      })

        },
  
});

export const { resetProductState } = polistSlice.actions;
export default polistSlice.reducer;